import { Observable } from 'rxjs';
import { StaticDependenciesService } from '../services/StaticDependenciesService';
import { StoreCacheKeys } from '../enums';

type Descriptor<T> = TypedPropertyDescriptor<(...args: any[]) => Observable<T>>;

export function ReloadCache<T>(key?: StoreCacheKeys): (target: object, propertyKey: string, descriptor: Descriptor<T>) => Descriptor<T> {

  return (target: object, propertyKey: string, descriptor: Descriptor<T>): Descriptor<T> => {

    const originalMethod: (...args: any[]) => Observable<T> = descriptor.value!;

    descriptor.value = function(...args: any[]): Observable<T> {

      const storeService = StaticDependenciesService.storeService;
      const prototype = storeService.constructor.prototype;

      if (key) {
        const modifiedPropertyKey = key + 'Cache$';

        if (prototype[modifiedPropertyKey]) {
          delete prototype[modifiedPropertyKey];
        }
      } else {
        Object.keys(prototype)
          .filter(k => k.endsWith('Cache$'))
          .forEach(k => delete prototype[k]);
      }

      return originalMethod.call(this, ...args);
    };

    return descriptor;
  };
}
